/*登陆*/
const login = resolve => require(["./page/login/Index.vue"], resolve);
/*首页主体*/
const home = resolve => require(["./page/index/home/Index.vue"], resolve);
const homeIndex = resolve => require(["./page/index/home/index/Index.vue"], resolve);

const routers = [{
    path: "/",
    name: "login",
    component: login,
    redirect: "home"
  },
  {
    /*首页主体*/
    path: "/home",
    component: home,
    redirect: "/home/index",
    children: [{
      /*基本信息*/
      path: "index",
      component: homeIndex,
      meta: {
        name: "/home/index"
      }

    }]
  }
];

export default routers;



// WEBPACK FOOTER //
// ./src/router.js